<script>
    import {onMount} from "svelte";
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    let polylinePath;

    const {pathStart} = labels;

    onMount(() => {
        mainTimeline
            .from('.drop', {
                opacity: 0,
                duration: 0.5,
            }, pathStart)
            .to('.drop', {
                y: 0,
                duration: 0.5,
                ease: 'Bounce.easeOut',
            }, pathStart)
            .to('.drop', {
                y: "30px",
                duration: 0.5,
                ease: 'Bounce.easeOut',
            }, '>')
            .to('.drop', {
                y: "-40px",
                x: "121px",
                duration: 0.5,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "67px",
                x: "308px",
                duration: 0.5,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "36px",
                x: "360px",
                duration: 0.15,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "6px",
                x: "360px",
                duration: 0.3,
                ease: 'Bounce.easeOut',
            }, '>')
            .to('.drop', {
                y: "36px",
                x: "360px",
                duration: 0.2,
                ease: 'Bounce.easeOut',
            }, 'path0')
            .to('.drop', {
                y: "-5px",
                x: "432px",
                duration: 0.25,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-184px",
                x: "123px",
                duration: 0.65,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-213px",
                x: "170px",
                duration: 0.25,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-243px",
                x: "170px",
                duration: 0.1,
                ease: 'Bounce.easeOut',
            }, '>')
            .to('.drop', {
                y: "-213px",
                x: "170px",
                duration: 0.3,
                ease: 'Bounce.easeOut',
            }, 'path1')
            .to('.drop', {
                y: "-237px",
                x: "215px",
                duration: 0.25,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-112px",
                x: "431px",
                duration: 0.5,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-147px",
                x: "491px",
                duration: 0.25,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-177px",
                x: "491px",
                duration: 0.2,
                ease: 'Bounce.easeOut',
            }, '>')
            .to('.drop', {
                y: "-147px",
                x: "491px",
                duration: 0.2,
                ease: 'Bounce.easeOut',
            }, 'pathEnd')
            .to('.drop', {
                y: "-183px",
                x: "555px",
                duration: 0.25,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                y: "-272px",
                x: "400px",
                duration: 0.5,
                ease: 'linear',
            }, '>')
            .to('.drop', {
                opacity: 0,
                duration: 0.5,
                ease: 'linear',
            }, '>-=0.1')
        ;
    });
</script>

<svg id="path" xmlns="http://www.w3.org/2000/svg" width="700px" x="600" y=200 viewBox="0 0 579.54 432.04"
     overflow="visible">
    <g class="drop">
        <path class="peachShape"
              d="M0,328.39c0-10.45,8.3-18.75,18.75-18.75s18.75,8.3,18.75,18.75c0,13.95-18.75,31.25-18.75,31.25,0,0-18.75-17.3-18.75-31.25Z"/>
    </g>
</svg>


<style>
    .peachShape {
        fill: #f5d2b5;
        stroke: none;
    }

    .drop {
        transform: translate(0px, 30px);
    }
</style>

